import React from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'
import {useTheme} from 'emotion-theming'
import {Field, useFormikContext} from 'formik'

import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'
import {getCountryCodeFromLanguage} from '@daedalus/core/src/localization/services/country'

import InputSelect from '../../../../designSystem/InputSelect'
import InputWrapperFormik from '../../../../designSystem/InputWrapperFormik'
import Flag from '../../../../designSystem/Flag'

import {LanguageType} from '@daedalus/core/src/localization/types/LanguageType'

interface Props {
  /** The id of the field */
  fieldId: string
  /** List of available languages */
  availableLanguages: LanguageType[]
  /** Callback that fires when the select is clicked */
  onClick?: () => void
}

export const FlagWrapper = styled('div')(
  ({theme}) => css`
    margin-top: ${theme.layout.spacing.s500}px;
  `
)

export const LanguageSelect = ({
  fieldId,
  availableLanguages,
  onClick
}: Props) => {
  const {
    values: {language}
  } = useFormikContext()

  const theme = useTheme()
  const countryCode = getCountryCodeFromLanguage(language)

  return (
    <InputWrapperFormik Field={Field} name={fieldId}>
      <InputSelect
        withChevron
        withBorder
        withIconPrepended
        withValidationIcon={false}
        dataId="PreferencesPopup-language"
        id={fieldId}
        Icon={
          <FlagWrapper>
            <Flag countryCode={countryCode} />
          </FlagWrapper>
        }
        placeholder={
          <FormattedMessageWrapper
            id="preferencesPopup.languageSelect.placeholder"
            defaultMessage="Language"
          />
        }
        onClick={onClick}
      >
        {availableLanguages?.map(({code, displayName}) => (
          <option key={code} value={code}>
            {displayName}
          </option>
        ))}
      </InputSelect>
    </InputWrapperFormik>
  )
}
